export default __webpack_public_path__ + "static/media/three-dots-vertical.6b3c1073.svg";